// extracted by mini-css-extract-plugin
export var externalLink = "_b5-0";
export var internalLinkLabel = "_b5-1";